import Vue from 'vue';
import on from 'dom-event';
import debounce from 'lodash/debounce';
import { isTablet, intersectionObserver } from 'utils/general';
import { trackBannerView } from 'lib/tracking';
import {Autoplay, EffectFade, A11y, Keyboard} from "swiper/modules";

export default (el) =>
  new Vue({
    el,
    name: 'Educational',
    components: {
      'vue-swiper':  () => import('../vue-swiper/vue-swiper.vue'),
    },
    data() {
      return {
        idList: el.dataset.ids.split('||'),
        nameList: el.dataset.names.split('||'),
        componentName: document.body.dataset.origin + '/' + el.dataset.componentName,
        siteSection: el.dataset.siteSection,
        selectedIndex: 0,
        swiperOptions: {
          slidesPerView: 1,
          effect: 'fade',
          a11y: true,
          keyboard: true,
          fadeEffect: {
            crossFade: true
          },
          autoplay: Number(el.dataset.autoplay) > 0 ? { delay: Number(el.dataset.autoplay) }: false,
          modules: [Autoplay, EffectFade, A11y, Keyboard],
          on: {
            slideChange: (swiper) => {
              this.selectedIndex = swiper.activeIndex;
            }
          }
        },
        isTablet: isTablet(),
      };
    },
    mounted() {
      on(window, 'resize', debounce(this.onResize, 300));
      intersectionObserver(this.$el, this.handleBannerViewTracking);
    },
    methods: {
      handleBannerViewTracking() {
        trackBannerView({
          id: this.idList[this.selectedIndex],
          name: this.nameList[this.selectedIndex],
          component_name: this.componentName,
          site_section: this.siteSection,
          shopify_module_name: 'educational'
        })
      },
      onResize() {
        this.$nextTick(() => {
          this.isTablet = isTablet();
        });
      },
      goToSlide(index) {
        this.$refs.carousel.select(index);
      },
    },
  });
